import { useSearchParams } from 'react-router-dom';
import { isMockEnabled } from '@/mocks';
import { usePassbook } from '@/shared/lib/passbook';
import { isDemoScenario } from '@/features/marketing-shared';

export function useSmsMarketingPaths() {
  const { idPassbook } = usePassbook();
  const [params] = useSearchParams();
  const raw = params.get('cenario');
  // O cenário só existe no modo mock; fora dele a URL fica limpa.
  const scenario = isMockEnabled() && isDemoScenario(raw) ? raw : null;
  const root = `/loja/${idPassbook}/sms-marketing`;

  const withScenario = (path: string) => {
    if (!scenario || scenario === 'normal') return path;
    const [pathname, query = ''] = path.split('?');
    const next = new URLSearchParams(query);
    next.set('cenario', scenario);
    const qs = next.toString();
    return qs ? `${pathname}?${qs}` : pathname;
  };

  return {
    root,
    list: withScenario(`${root}/campanhas`),
    create: `${root}/campanhas/nova`,
    detail: (id: string) => withScenario(`${root}/campanhas/${id}`),
    edit: (id: string) => withScenario(`${root}/campanhas/${id}/editar`),
    settings: withScenario(`${root}/configuracao`),
  };
}
